<template>
  <div>
    <CCard></CCard>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <div class="flex">
              <h1>Importowanie cen zakupu</h1>

              <CButton
                v-if="false"
                color="warning"
                class="btnAddToTree"
                @click="mthAddNewRepresentative()"
                >Importuj</CButton
              >
            </div>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="12">
                <file-upload
                  :url="mthFileUploadUrl()"
                  @change="mthVFileUploadFileChange"
                  @success="mthVFileUploadFileSuccess"
                  @error="mthVFileUploadFileError"
                  @progress="mthVFileUploadFileProgress"
                  btn-label="Załaduj plik"
                  btn-uploading-label="Trwa wysyłanie pliku"
                  accept=".xlsx"
                ></file-upload>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12">
                <CRow>
                  <CCol sm="12">Plik musi mieć rozszerzenie XLSX (format Excel 2007)</CCol>
                </CRow>
                
                <CRow>
                  <CCol sm="12"> Wymagana postać źródłowego pliku excel: </CCol>
                </CRow>
                <CRow>
                  <CCol sm="12">
                    <img src="img/importbuyingprices.png" style="width:60vw" />
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import { freeSet } from "@coreui/icons";
import Message from "./Message";

export default {
  name: "b2bbuyingpricesimport",
  freeSet,
  data() {
    return {};
  },
  created(){
    
  },
  methods: {
    mthFileUploadUrl() {
      let url=process.env.VUE_APP_IMG_UPLOAD_URL + "?totemp=buyingpricestoimport";
      //console.log(url);
      return url;
    },
    mthVFileUploadFileChange() {console.log('change');},
    mthVFileUploadFileSuccess() {this.$router.push({ name: 'message', params: { cap: 'OK, zaimportowano.' } });},
    mthVFileUploadFileError() {console.log('err');},
    mthVFileUploadFileProgress() {console.log('progr');},

  },
};
</script>

<style scoped>
input[type="text"] {
  width: 100%;
  background-color: yellow;
  height: 100%;
}
</style>